<template>
  <div class="profile-form-card security-form-card">
    <el-form ref="form" class="profile-form" :model="user" :rules="rules" size="small" label-position="top">
      <el-row :gutter="22">
        <el-col :xs="24" :sm="12">
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="user.newPassword"
              placeholder="8-20位，包含大小写字母和数字"
              type="password"
              prefix-icon="el-icon-lock"
              clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="user.confirmPassword"
              placeholder="请确认密码"
              type="password"
              prefix-icon="el-icon-key"
              clearable>

            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="form-actions">
            <el-button type="primary" @click.stop.native="submit">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
export default {
  name: 'ResetPwd',
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      // 表单校验
      rules: {
        // oldPassword: [
        //   {required: true, message: "旧密码不能为空", trigger: "blur"}
        // ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          // { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z]{8,20}$/,
            message: '必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-20之间',
            trigger: ['change','blur']
          }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { required: true, validator: equalToPassword, trigger: 'blur' }
        ]
      },
      hasPwd: true//是否有密码
    }
  },
  methods: {
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$api.updateUserPwd(this.user.oldPassword, this.user.newPassword).then(() => {
              // console.log(response)
              // this.msgSuccess("修改成功");
              this.$alert('【确认】后返回登录页面', '修改成功', {
                confirmButtonText: '确定',
                callback: action => {
                  if (action) {
                    this.handleLogout()
                  }
                  // this.$message({
                  //   type: 'info',
                  //   message: `action: ${action}`
                  // });
                }
              })
            }
          )
        }
      })
    },
    // 处理退出
    handleLogout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` })
        // location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    async checkHasPwd() {
      //判断用户是否已经有密码了
      const { info } = await this.$api.checkUserPwd()
      this.hasPwd = !!info
    }
  },
  created() {
    this.checkHasPwd()
  }
}
</script>

<style scoped>
.profile-form-card {
  max-width: 760px;
}

.security-form-card {
  min-height: 210px;
}

.profile-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

.profile-form ::v-deep .el-form-item__label {
  padding-bottom: 7px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.profile-form ::v-deep .el-input__inner {
  height: 36px;
  border-color: #d8dee9;
  border-radius: 6px;
  color: #1f2937;
}

.profile-form ::v-deep .el-input__inner:focus {
  border-color: #ff3176;
}

.profile-form ::v-deep .el-input__prefix {
  color: #98a2b3;
}

.form-actions {
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid #edf1f6;
  text-align: right;
}

.form-actions ::v-deep .el-button {
  min-width: 96px;
  height: 36px;
  border-radius: 6px;
  font-weight: 600;
}
</style>
